import axios from "axios";

export const facilitiesService = {
    getFacilitiesService: (params) =>
        axios.get("/facilities", {auth: true, params: {...params}}),
    deleteFacilitiesService: (id) =>
        axios.delete(`/facilities/${id}`, {auth: true}),
    addFacilitiesService: (body) =>
        axios.post("/facilities", body, {auth: true}),
    editFacilitiesService: (id, body) =>
        axios.patch(`/facilities/${id}`, body, {auth: true}),

    changeStatusFacilitiesService: (id, body) =>
        axios.patch(`/facilities/${id}/status`, body, {auth: true}),
};
